// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, buscas, caminhos, catálogo e os carregadores.
export {
  conciliationDetailScreen,
  conciliationHubScreen,
  conciliationListScreen,
  conciliationNewScreen,
} from './conciliation.screen';
export { suspenseAccountDetailScreen, suspenseAccountListScreen } from './suspense-account.screen';
export { suspenseAccountDetailSearch, suspenseAccountListSearch } from './suspense-account.search';
export { dataprevListSearch, detailSearch, newConciliationSearch } from './conciliation.search';
export { CONCILIATION_PATH, DATAPREV_PATH, LEGACY_TAB_SEGMENTS } from './conciliation.paths';
export { loadConciliationMessages } from './conciliation.catalog';

/** As telas das rotas, por `lazyScreen`. */
export const loadConciliationScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadConciliationGuides = () => import('./conciliation.guide');
